import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import TagGroupDetail, { TagGroupDetailSku, TagListOfGroup } from './../models/TagGroupDetail';
import TagGroup from './../models/TagGroup';
import { get } from 'lodash';
import { ORDER } from '../constants/Define';

const SKU_URL_MAPPING = {
  [ORDER.TYPES.VOUCHER.key]: Urls.GROUP_LIST_ALL,
  [ORDER.TYPES.TOUR.key]: Urls.TOUR_ALL,
  [ORDER.TYPES.VINWONDER.key]: Urls.VIN_WONDER_ALL,
  [ORDER.TYPES.HOTEL.key]: Urls.HOTEL_ALL,
}
const BASE_URL_MAPPING = {
  [ORDER.TYPES.VOUCHER.key]: Config.API_VOUCHER,
  [ORDER.TYPES.TOUR.key]: Config.API_TOUR,
  [ORDER.TYPES.VINWONDER.key]: Config.API_VOUCHER,
  [ORDER.TYPES.HOTEL.key]: Config.API_HOTEL,
}

export function getAllTagGroup() {
  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.TAG_GROUP_ALL,
    parser: data => (get(data, 'data') || []).map(item => new TagGroup(item)),
  }).get();
}

export function getTagGroupDetails(params) {
  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.TAG_GROUP_DETAIL_LIST,
    params: params,
    parser: tagGroupDetailParser,
  }).get();
}

export function getAllTagGroupDetails(params) {
  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.TAG_GROUP_DETAIL_ALL,
    params: params,
    parser: tagGroupDetailParser,
  }).get();
}

export function getTagGroupDetailItem(id) {
  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.TAG_GROUP_DETAIL_ITEM,
    endpointParams: { id },
    parser: (data) => new TagGroupDetail(data.data),
  }).get();
}

export function createTagGroupDetail(tagGroupDetail) {
  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.TAG_GROUP_DETAIL_CREATE,
    parser: (data) => new TagGroupDetail(data.data),
  }).post(tagGroupDetail.export());
}

export function updateTagGroupDetail(tagGroupDetail) {
  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.TAG_GROUP_DETAIL_UPDATE,
  }).put(tagGroupDetail.export());
}

export function deleteTagGroupDetail(tagGroupDetail) {
  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.TAG_GROUP_DETAIL_DELETE,
    endpointParams: { id: tagGroupDetail.id },
  }).delete();
}

//TRANSLATE
export function createTagGroupDetailTranslate(tagGroupDetail) {
  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.TAG_GROUP_DETAIL_TRANSLATE_CREATE,
  }).post(tagGroupDetail.export(true).translate());
}

export function updateTagGroupDetailTranslate(tagGroupDetail) {
  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.TAG_GROUP_DETAIL_TRANSLATE_UPDATE,
  }).put(tagGroupDetail.export(true).translate());
}

export function deleteTagGroupDetailTranslate(id) {
  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.TAG_GROUP_DETAIL_TRANSLATE_DELETE,
    endpointParams: { id },
  }).delete();
}

export function getAllSku(typeKey, params = {}) {
  const endpoint = SKU_URL_MAPPING[typeKey]
  const baseURL = BASE_URL_MAPPING[typeKey]
  return new ApiService({
    baseURL, endpoint, params,
    parser: allSkuParser,
  }).get();
}

export function mapSkus({ tagGroupDetailId, inserts = [], deletes = [], typeId, hotelRatePlans = null }) {
  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.TAG_GROUP_DETAIL_MAP_SKU,
  }).post({ tagGroupDetailId, inserts, deletes, type: typeId , hotelRatePlans});
}

export function getTagInTagGroup(params) {
  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.TAG_IN_TAG_GROUP,
    params: params,
    parser: tagGroupDetailParser,
  }).get();
}

export function getTagBySku(id) {
  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.TAG_BY_SKU,
    endpointParams: { id },
    parser: tagGroupDetailSKUParser,
  }).get();
}

export function updateTagGroupSKUMapping(skuTags) {
  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.TAG_GROUP_SKU_MAPPING_UPDATE,
  }).post(skuTags);
}

export function getTagsByGroup(params) {
  return new ApiService({
    baseURL: Config.API_CMS,
    endpoint: Urls.TAGS_BY_GROUP,
    params: params,
    parser: ({data}) => data.map(x=>x.tagGroupDetails).flat(),
  }).get();
}

function tagGroupDetailParser(data = {}) {
  return {
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount,
    result: (data.data.result || []).map(item => new TagGroupDetail(item))
  }
}

function tagGroupDetailSKUParser(data = {}) {
  return {
    tagGroupSKU: (data.data || []).map(item => {
      return {
        tagGroup: new TagGroup(item.tagGroup),
        tagList: (item.tagList || []).map(it => new TagListOfGroup(it))
      }
    })
  }
}

function allSkuParser(data = {}) {
  let dataArray;
  if (Array.isArray(data)) {
    dataArray = data;
  } else {
    dataArray = get(data, 'data') || []
  }
  return dataArray.map(item => new TagGroupDetailSku(item))
}
